import { useEffect, useState } from "react";
import { Method_POST } from "../../../../../../../service/api";
import { formatarData } from "../../../../../../../function/utilis/function";
import { Alert, Timeline } from "antd";

import { Pagination, Stack } from "@mui/material";

import style from "./style.module.css"

export function GroupHistorico({ numeroSolicitacao }) {

  const [loadings, setLoadings] = useState([]);
  const [dados, setDados] = useState([]);
  const [page, setPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    fetchHistorico();
  }, [numeroSolicitacao]);

  const fetchHistorico = async () => {
    setLoadings(true);
    try {
      const url = `/ordem-servico/historico/listar`;
      const data = { id: numeroSolicitacao };

      const responseData = await Method_POST(url, data);

      if (responseData && responseData.length > 0) {
        setDados(responseData);
      } else {
        setDados([])
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoadings(false)
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  // Filtrar os dados para exibir apenas os itens da página atual
  const paginatedData = dados.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const timelineItems = paginatedData.map((historico) => ({
    className: style.timelineItem,
    children: (
      <div className={style.cardHist}>
        <div className={style.linhaCampo}>
          <span className={style.label}>Data</span>
          <span className={style.valor}>
            {historico.dataSituacao === "" || historico.dataSituacao === null
              ? "Data não declarada"
              : formatarData(historico.dataSituacao)}
          </span>
        </div>
        <div className={style.linhaCampo}>
          <span className={style.label}>Situação</span>
          <span className={style.valor}>
            {historico.situacao?.nome === "" || historico.situacao?.nome === null
              ? "Nenhuma situação"
              : historico.situacao?.nome}
          </span>
        </div>
        <div className={style.linhaCampo}>
          <span className={style.label}>Usuário</span>
          <span className={style.valor}>
            {historico.usuarioSituacao?.id === "" || historico.usuarioSituacao?.id === null
              ? "Nenhum usuário"
              : historico.usuarioSituacao?.id}
          </span>
        </div>
        <div className={style.linhaCampo}>
          <span className={style.label}>Motivo</span>
          <span className={style.valor}>
            {historico.motivoSituacao?.nome === "" || historico.motivoSituacao?.nome === null
              ? "Nenhum motivo declarado"
              : historico.motivoSituacao?.nome}
          </span>
        </div>
      </div>
    ),
  }));

  return (
    <div className={style.tabelaContainerHist}>
      {paginatedData.length > 0 ? (
        <Timeline className={style.timelineWrapper} items={timelineItems} />
      ) : (
        <Alert
          message="Nenhum documento disponível."
          type="info"
          showIcon
        />
      )}

      <Stack spacing={2} style={{ alignItems: "center" }}>
        <Pagination
          count={Math.ceil(dados.length / itemsPerPage)}
          page={page}
          onChange={handleChange}
        />
      </Stack>
    </div>
  );
}

export default GroupHistorico;